import * as React from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import constantsStorage from 'constants/Storage';
import useNotProcessedOrders from 'types/hooks/useNotProcessedOrders';
import ShoppingCart from 'types/models/ShoppingCart';
import OrderContext from 'contexts/OrderContext';
import { storeFoodTruckOrder } from 'services/ordersService';

export default (): useNotProcessedOrders => {
  const { currentVenue, isConnected } = React.useContext(OrderContext);

  const storeNotProcessedOrder = async (shoppingCart: ShoppingCart): Promise<void> => {
    try {
      const notProcessedOrders = await AsyncStorage.getItem(constantsStorage.notProcessedOrders);
      if (notProcessedOrders) {
        const orders = JSON.parse(notProcessedOrders);
        orders.push(shoppingCart);
        await AsyncStorage.setItem(constantsStorage.notProcessedOrders, JSON.stringify(orders));
      } else {
        await AsyncStorage.setItem(constantsStorage.notProcessedOrders, JSON.stringify([shoppingCart]));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeNotProcessedOrders = async (): Promise<void> => {
    try {
      await AsyncStorage.removeItem(constantsStorage.notProcessedOrders);
    } catch (error) {
      console.log(error);
    }
  };

  const getStoredPendingOrders = async (): Promise<ShoppingCart[] | null> => {
    try {
      const storedOrders = await AsyncStorage.getItem(constantsStorage.notProcessedOrders);
      if (storedOrders) {
        const parsedOrders: ShoppingCart[] = JSON.parse(storedOrders);
        return parsedOrders;
      }
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const processPendingOrders = React.useCallback(async () => {
    if (!currentVenue) return;
    if (isConnected) {
      const ordersInStorage = await getStoredPendingOrders();
      if (ordersInStorage) {
        const promisesProcessingOrders = ordersInStorage.map(
          async (pendingOrder: ShoppingCart) =>
            await storeFoodTruckOrder(pendingOrder, currentVenue.id, currentVenue.localDateTimeIdentifier),
        );
        const processedOrders = await Promise.all(promisesProcessingOrders);
        if (processedOrders) {
          await removeNotProcessedOrders();
        }
      }
    }
  }, []);

  return { storeNotProcessedOrder, processPendingOrders };
};
